/**
 * * Adapted from the original function in the PDP Backbone code
 * @see {@link src/helpers/pickupMessaging.js}
 * @param {Object} options
 * @param {boolean} options.inStorePickupEligibility
 * @param {boolean} options.curbsidePickupEligibility
 * @returns {string}
 */
export const checkPickupEligibility = ({ inStorePickupEligibility = false, curbsidePickupEligibility = false }) => {
  let conditionalCheck = '';
  switch (true) {
    case inStorePickupEligibility && curbsidePickupEligibility:
      conditionalCheck = 'bothEligible';
      break;
    case inStorePickupEligibility === true && curbsidePickupEligibility === false:
      conditionalCheck = 'inStoreEligibleOnly';
      break;
    case inStorePickupEligibility === false && curbsidePickupEligibility === true:
      conditionalCheck = 'curbsideEligibleOnly';
      break;
    default:
      conditionalCheck = 'notEligible';
      break;
  }
  return conditionalCheck;
};
